export * from "./partner-create-account-template";
